import axios from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const getPlaylist = async () => {
  return axios.get(`${serviceBaseUrl}/guests/CURRENT/playlists`)
}

export const deletePlaylistItem = async (playlistItem) => {
  return axios.delete(`${serviceBaseUrl}/guests/CURRENT/playlists/items/${playlistItem?.contentUUID}`)
}

export const addPlaylistItem = async (playlistItem) => {
  return axios.put(
    `${serviceBaseUrl}/guests/CURRENT/playlists/items/${playlistItem?.contentUUID}?type=${playlistItem.type}`
  )
}

export const setPlaylistItemAsWatched = async (cmsId) => {
  return axios.post(`${serviceBaseUrl}/guests/CURRENT/playlists/items/${cmsId}`, { watched: true })
}

export const updatePlaylistItem = async ({ playlistItem, method }) => {
  if (method === 'PUT') {
    return addPlaylistItem(playlistItem).then(() => {
      return getPlaylist()
    })
  }
  if (method === 'DELETE') {
    return deletePlaylistItem(playlistItem).then(() => {
      return getPlaylist()
    })
  }

  return getPlaylist()
}
